import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';

/**
 * @class
 *
 * PhotoPack page.
 */
const MiscElectricalPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    s3;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    postRequestOpp = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Company__c",
            "Substantial__c",
            "Substantial__r.Name",
            "Ground_Mount__c",
            "Days_to_Clawback__c",
            "Site_Visits__c",
            "Location__r.Name"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    postRequestSession = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Field_Job__c",
            "Assigned_Crew__r.Work_Phone_Number__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    postRequestWorkOrder = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Assigned_Field_Team__c", 
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c",
            "Review_Submitted__c",
            "Number_of_Days__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        errorMessage: '',
        opp: {},
        session: {},
        slackResponse: '',
        sendingToSlack: false,
        tier3rtr: false,
        isPast6PM: false,
        isWorkOrder: false,

        MiscElectrical: {},
        MiscElectricalError: false,

        MiscElectricalArray: []
    }

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);

        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(newState => {
            this.setState(newState);
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });

        const now = new Date();
        const pstTime = moment(now, "America/Los_Angeles");
        if (pstTime.hour() >= 18) {
            this.setState({ isPast6PM: true });
        }

        await this.getOpp();

        const isWorkOrder = this.sessId.startsWith('a0j');
        this.setState({ isWorkOrder });

        if (isWorkOrder) {
            await this.getWorkOrder();
        } else {
            await this.getSession();
        }
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getOpp = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpp,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({opp: data});

                if((data.Days_to_Clawback__c !== null && data.Days_to_Clawback__c < 30) || data.Site_Visits__c >= 6) {
                    this.setState({tier3rtr: true});
                }
            })
            .catch(err => console.log('POST Error Opp:\n', err));
    };

    getSession = async() => {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSession,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    };

    getWorkOrder = async() => {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postRequestWorkOrder,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    }

    capturePhoto = async(file, stateName, stateNameError) => {
        if (!file || this.state.uploading) return;
                
        try {
            await uploadSinglePhoto({
                file,
                stateName,
                stateNameError,
                username: this.username,
                opportunityId: this.opportunityId,
                type: this.type,
                setState: this.setState.bind(this),
                source: this.source
            });
        } catch(err){
            console.log(err)
        }
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    addAnotherPic = (array, fileName, displayName) => {
        let picNumber = this.state[array].length + 1;
        let stateName = fileName + picNumber.toString()
        this.setState({
            [array]: [...this.state[array], stateName],
            [stateName] : {}
        })
    };

    sendToSlack = () => {
        this.setState({sendingToSlack: true});

        let message = 'Miscellaneous Electrical Photos Review for: <https://v3electric.my.site.com/frontendOps/s/detail/' +  this.state.opp.Id + '|' +  this.state.opp.Name +'>\n' +
            'Field Tech: ' + this.props.user.name + '\n' +
            'Photo Pack Page: <https://v3electric.my.site.com/frontendOps/s/sfdcpage/%2Fapex%2FPhotoPackOppS3%3F%26id%3D' + this.state.opp.Id + '|Photo Pack>\n' +
            'Work Order: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.session.Id + '|' +  this.state.session.Name +'>\n' +
            'Substantial: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.opp.Substantial__c + '|' +  this.state.opp.Substantial__r.Name +'>\n' +
            'Financier: ' + this.state.opp.Company__c + '\n' +
            'Location: ' + this.state.opp.Location__r.Name + '\n' +
            'Number of Days: ' + this.state.session.Number_of_Days__c;

        // test-api channel id C06JN84MGFM
        // tier 1 rtr id: C07UMTF64TE
        // tier 2 rtr id: C07UGHTQ7M3
        // tier 3 rtr id: C07V87JGTFS

        let channelId = '';

        if((this.state.opp.Days_to_Clawback__c > 30 || this.state.opp.Days_to_Clawback__c === null) && this.state.opp.Site_Visits__c < 6) {
            channelId = 'C07UGHTQ7M3'; // tier 2
        } else if((this.state.opp.Days_to_Clawback__c !== null && this.state.opp.Days_to_Clawback__c < 30) || this.state.opp.Site_Visits__c >= 6) {
            channelId = 'C07V87JGTFS'; // tier 3
            if(this.state.isWorkOrder){
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c;
            } else {
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Crew__r.Work_Phone_Number__c;
            }
        } else {
            channelId = 'C07UMTF64TE'; // default to tier 1
        }

        let payload = {
            "channel": channelId,
            "text": message
        };

        axios.post(
            '/slackMessage', 
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({slackResponse: 'Notification sent to Slack successfully', sendingToSlack: false});

                // Review Submitted on WO is used for reporting on when field team initially requested RTR.
                if(this.state.isWorkOrder && !this.state.session.Review_Submitted__c){
                    let woPayload = {
                        Id: this.sessId,
                        Review_Submitted__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                    };

                    axios.put(
                        '/sf/WorkOrder/update', 
                        woPayload, 
                        {
                            cancelToken: this.source.token
                        })
                        .catch(err => console.log('PUT Error Updating WO on RTR Request:\n', err));
                }

                setTimeout(() => {
                    this.setState({slackResponse: ''});
                }, 3000);
            })
            .catch(err => {
                console.log('POST Error Sending Slack Message:\n', err);
                this.setState({slackResponse: 'Failed to send to Slack: ' + err.message, sendingToSlack: false});
            });
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>Misc Electrical Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>
                
                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                        {
                            this.state.tier3rtr ? 
                                this.state.isPast6PM ? 
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Reviewers are unavailable at this time. Please be prepared to have a phone review tomorrow morning.</h2>
                                :
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Please sit tight until you receive a call from the RTR team to conduct the review.</h2>
                                :
                                <></>
                        }

                        <table>
                            <tbody>

                                {/* Work Completed Today Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.MiscElectrical).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Work Completed Today</div>
                                            :
                                            this.state.MiscElectricalError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Photo: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.MiscElectrical)}><FontAwesomeIcon icon={faCircle} /> Work Completed Today</button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="MiscElectrical" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="MiscElectrical" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'MiscElectrical', 'MiscElectricalError')} /></td>
                                    <td className="w-25"><label for="MiscElectricalUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="MiscElectricalUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'MiscElectrical', 'MiscElectricalError')}/></td>
                                </tr>

                                {/* Misc Electrical Array Photos */}
                                {
                                    this.state.MiscElectricalArray.length !== 0 ? 
                                    
                                    this.state.MiscElectricalArray.map(t =>
                                        <tr>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label for={t} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label for={t + 'Upload'} class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Photo</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('MiscElectricalArray', 'MiscElectrical-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(MiscElectricalPhotoPack);